module.exports = __webpack_public_path__ + "media/site/images/logos/sabner-logo-6806eeeb321bea79d99d8750ea909300.png";